import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatNum' })
export class FormatNumPipe implements PipeTransform {
    transform(value: any): string {
        return (value || value === 0)
            ? new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(value)
            : '';
    }
}
